/** 意约官网接口
 *  kxx
 */

import {
  get,
  post,
  del
} from './helpers';
import {
  baseUrl
} from '../axios/conf';
export default {
  // 获取banner列表
  async getBannerList(params) {
    const res = await get(`${baseUrl}/osApi/getBannerList`)(params);
    return res.data;
  },

  //获取合作伙伴
  async getPartnersList(params) {
    const res = await get(`${baseUrl}/osApi/getPartnersList`)(params);
    return res.data;
  },

  //获取资讯数据
  async getConsultingList(params) {
    const res = await get(`${baseUrl}/osApi/getConsultingList`)(params);
    return res.data;
  },

  //底部留言
  async addLeavingMsg(data) {
    const res = await post(`${baseUrl}/osApi/addLeavingMsg`)(data);
    return res.data;
  },

  //获取资讯分页列表
  async getConsulting(params) {
    const res = await get(`${baseUrl}/osApi/getConsultingPage`)(params);
    return res.data;
  },

  // 获取资讯详情
  async getConsultingDetail(params) {
    const res = await get(`${baseUrl}/osApi/getConsultingDetail`)(params);
    return res.data;
  },
  // 获取该资讯，上下资讯
  async getConsultingUpDownList(params) {
    const res = await get(`${baseUrl}/osApi/getConsultingUpDownList`)(params);
    return res.data;
  },
  // 验证码发送
  async postSendVerifyCode(params) {
    const res = await post(`${baseUrl}/osApi/sendVerifyCode`)(params);
    return res.data;
  },
  // 获取重大活动分页列表
  async getMajorEvents(params) {
    const res = await get(`${baseUrl}/osApi/getMajorEventsPage`)(params);
    return res.data;
  },

  //投诉建议接口 
  async addComplaints(data) {
    const res = await post(`${baseUrl}/osApi/addComplaints`)(data);
    return res.data;
  },

  //获取客户说数据
  async getCustomerSaidList(params) {
    const res = await get(`${baseUrl}/osApi/getCustomerSaidList`)(params);
    return res.data;
  },
  //获取客户说轮播数据
  async getCustomerSaidPage(params) {
    const res = await get(`${baseUrl}/osApi/getCustomerSaidPage`)(params);
    return res.data;
  },

  //获取爆款课程
  async getCourseManageList(params) {
    const res = await get(`${baseUrl}/osApi/getCourseManageList`)(params);
    return res.data;
  },

  //获取学院口碑列表 
  async getStudentManageList(params) {
    const res = await get(`${baseUrl}/osApi/getStudentManageList`)(params);
    return res.data;
  },

  //讲师列表接口
  async getInstructorTeamList(params) {
    const res = await get(`${baseUrl}/osApi/getInstructorTeamList`)(params);
    return res.data;
  },

  // 添加代理商申请
  async addAgentApply(params) {
    const res = await post(`${baseUrl}/osApi/addAgentApply`)(params);
    return res.data;
  },
};
